import React, { useState, useEffect } from "react";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Autocomplete,
  Typography,
  TextField,
  CircularProgress,
  InputAdornment,
  Box,
  Backdrop,
} from "@material-ui/core";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { calculateTax, getTaxCode, getWHTCodeByTaxCode } from "../../actions";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../InvoiceDetails/style";

import Select from "react-select";
import "./style.css";
import Spinner from "../../../Spinner/Spinnerv2";
const TaxDetailTextField= ({
  formState,
  setFormState,
  disabled,
  invoice_Amount,
  edit,
  roleName,
}) => {
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [taxCodeListLoading, setTaxCodeListLoading] = useState(true);
  const [taxCalculateLoading, setTaxCalculateLoading] = useState(false);
  const [selectedTaxCode, setSelectedTaxCode] = useState(null);

  const useStyles = makeStyles({dashboardStyle,
    label: {
      fontWeight: 'bold',
    },
  });
  const classes = useStyles();

  const spanStyle = {
    color: "#999",
    fontSize: "14px",
    cursor:"default",
  };
  const filterOptions = createFilterOptions({
    stringify: (taxCodeList) => taxCodeList.TaxCode + taxCodeList.C,
  });
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };
  useEffect(() => {
    getTaxCode(setTaxCodeList, setTaxCodeListLoading);
  }, []);

  const calculateTaxHandler = (checked) => {
    if (checked) {
      calculateTax(
        formState?.salesTaxCode,
        "PKR",
        invoice_Amount,
        setFormState,
        setTaxCalculateLoading
      );
    }

    setFormState((formState) => ({
      ...formState,
      calculateTax: checked,
    }));
  };
  useEffect(() => {
    if (
      formState?.salesTaxCode === "" &&
      taxCodeList.length > 0 &&
      !taxCodeListLoading
    ) {
      setFormState((formState) => ({
        ...formState,
        salesTaxCode: taxCodeList[0]?.TaxCode + " - " + taxCodeList[0]?.Description ,
      
      }));
    }
  }, [formState?.salesTaxCode, taxCodeList, taxCodeListLoading]);

  
  // useEffect(() => {
  // if(saletaxcode === "true"){

  //   setFormState((formState) => ({
  //     ...formState,
  //     salesTaxCode: taxCodeList[2]?.TaxCode ,
  //   }));
  // }

  // }, [formState?.salesTaxCode]);
  

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: "lightgray", // Change the background color of the control
      ":focus": {
        borderColor: "gray", // Change the background color on hover
        boxShadow: "black !important",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: "white", // Change the background color of the selected option
      color: "black",
      ":hover": {
        backgroundColor: "lightgray", // Change the background color on hover
      },
    }),
    menu: (base, state) => ({
      ...base,
      backgroundColor: "white", // Change the background color of the menu
      color: "white", // Change the font color of the menu
    }),
  };

  return (
    <>
      <Grid container spacing={1} style={{ margin: "10px 0px" }}>
       {/* <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={taxCodeListLoading}
          // invisible={taxCodeListLoading}
        >
          <Spinner />
  </Backdrop>*/}
        <Grid item xs={12} sm={12} md={6} lg={3} style={{ paddingLeft: "4px" }}>
          <Typography variant="h6" style={{ color: "black" }}>
            CNIC: {`  `}
            {formState.cnic}
          </Typography>{" "}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <Typography variant="h6" style={{ color: "black" }}>
            NTN:{`  `} {formState.ntn}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={1} style={{ margin: "20px 0px" }}>
        {/* {roleName !== "AP Supervisor" && ( */}
        <Grid item xs={12} sm={12} md={6} lg={3} style={{ marginTop: "0px" }}>
       <Typography  
        variant="h5"
        style={{ color: "black", fontStyle: "bold" }}>
        <Checkbox
                color="secondary"
                fontSize="small"
                checked={formState?.calculateTax || edit == "false"}
                onChange={(event) => {
                  calculateTaxHandler(event.target.checked);
                }}
                style={{ paddingLeft: "0px" }}
                disabled={edit == "false" ? true : false || disabled}
                disableRipple={true}
              />
        Calculate Tax{` `}

        </Typography>
         {/* <FormControlLabel
            label="Calculate Tax"
            color="secondary"
            control={
              
              
            }
          />*/}
        </Grid>
        {/* )} */}
        <Grid item xs={12} sm={12} md={6} lg={3} mt={1}>
          <Typography  
          variant="h5"
          style={{ color: "black", fontStyle: "bold" }}>
            Tax Code:{` `}
          <span style={spanStyle}>
          { formState?.salesTaxCode}
          </span>

          </Typography>
         {/* <Select
            className="basic-single"
            classNamePrefix="select"
            styles={customStyles}
            defaultValue={[taxCodeList[0]?.TaxCode]}
            value={{
              TaxCode: formState?.salesTaxCode?.split("-")[0] || "",
              Description:
                taxCodeList?.find(
                  (x) =>
                    x.TaxCode ===
                    formState?.salesTaxCode
                      ?.split("-")[0]
                      .replace(/^\s+|\s+$/gm, "")
                )?.Description || "",
            }}
            required
            // defaultValue={taxCodeList}
            // isDisabled={isDisabled}
            // isLoading={isLoading}
            // isClearable={isClearable}
            // isRtl={isRtl}
            isDisabled={edit == "false" ? true : false || disabled}
            isSearchable={true}
            name="color"
            onChange={(event, newValue) => {
              if (event?.TaxCode) {
                setFormState((formState) => ({
                  ...formState,
                  salesTaxCode: event?.TaxCode || "",
                  // salesTaxAmount: formState?.calculateTax
                  //   ? event?.DefaultValue
                  //   : formState.salesTaxAmount,
                }));

                formState?.calculateTax &&
                  calculateTax(
                    event?.TaxCode,
                    "PKR",
                    invoice_Amount,
                    setFormState,
                    setTaxCalculateLoading
                  );
                formState?.taxCard_List[0]?.taxType &&
                  getWHTCodeByTaxCode(setFormState, formState, event?.TaxCode);
              }
            }}
            options={taxCodeList}
            getOptionLabel={(option) =>
              (option &&
                `${option?.TaxCode} ${option?.TaxCode ? "-" : ""} ${
                  option?.Description
                }`) ||
              ""
            }
          />*/}
          {/* <Autocomplete
            id="selectedTaxCode"
            options={taxCodeList}
            size="small"
            name=""
            value={{
              TaxCode: formState?.salesTaxCode?.split("-")[0] || "",
              Description:
                taxCodeList?.find(
                  (x) =>
                    x.TaxCode ===
                    formState?.salesTaxCode
                      ?.split("-")[0]
                      .replace(/^\s+|\s+$/gm, "")
                )?.Description || "",
            }}
            // value={selectedTaxCode}
            getOptionLabel={(option) =>
              (option &&
                `${option?.TaxCode} ${option?.TaxCode ? "-" : ""} ${option?.Description
                }`) ||
              ""
            }
            disabled={edit == "false" ? true : false}
            key={(option) => option?.TaxCode}
            filterOptions={filterOptions}
            loading={taxCodeListLoading}
            onChange={(event, newValue) => {
              if (newValue?.TaxCode) {
                setFormState((formState) => ({
                  ...formState,
                  salesTaxCode: newValue?.TaxCode || "",
                  // salesTaxAmount: formState?.calculateTax
                  //   ? newValue?.DefaultValue
                  //   : formState.salesTaxAmount,
                }));

                formState?.calculateTax &&
                  calculateTax(
                    newValue?.TaxCode,
                    "PKR",
                    invoice_Amount,
                    setFormState,
                    setTaxCalculateLoading
                  );
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                // style={{    padding: "10px 10px 12px 10px",
                //   border: "1px solid #0000003b",
                //   borderRadius: "4px",
                //   width: "-webkit-fill-available",}}
                // className="MuiOutlinedInput-input MuiInputBase-input MuiInputBase-inputSizeSmall MuiInputBase-inputAdornedEnd css-19qh8xo-MuiInputBase-input-MuiOutlinedInput-input"
                name=""
                required={true}
                disabled={disabled}
                // sx={{
                //   "& fieldset": { border: 'none' },
                // }}
                value={""}
                placeholder="Select a Value"
                // onChange={(event) => {
                //   let objVendor = {
                //     target: { name: "vendor_Code", value: event.target.value },
                //   };
                //   changeHandler(objVendor, index);
                //   getVendorDetail(event.target.value, setVendorCode, setLoading);
                // }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          /> */}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} mt={1}>
          <Typography 
           variant="h5"
          style={{ color: "black", fontStyle: "bold" }}>
           Input Tax Amount:{` `}
          <span style={spanStyle}>{formState?.salesTaxAmount || 0}</span>

          </Typography>
         {/* <TextField
            fullWidth
            size="small"
            name="salesTaxAmount"
            type="number"
            value={formState?.salesTaxAmount || 0}
            required={formState.salesTaxAmount === ""}
            sx={{
              // width: "70%",
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
            InputProps={{
              inputProps: { min: 0, step: "0.001" },
              endAdornment: (
                <InputAdornment position="end">
                  {taxCalculateLoading && <CircularProgress size={24} />}
                </InputAdornment>
              ),
            }}
            id="outlined-basic"
            variant="outlined"
            onChange={changeHandler}
            disabled={formState.calculateTax || edit == "false" ? true : false}
          />
        */}
        </Grid>
      </Grid>
    </>
  );
};

export default TaxDetailTextField;
